class ApiResponse {

  constructor(data, headers, errors = []) {
    this.data = data;
    this.errors = errors || [];
    this.headers = headers;
  }

  get isOkay() {
    return this.errors.length === 0;
  }
}

export default ApiResponse;


// WEBPACK FOOTER //
// ./src/components/utils/ApiResponse.js